import request from '@/utils/request'
import {getCookie} from '@/utils/cookieUtils'

/**
 * 第三方登录
 * @param params
 */
export function login (params) {
  return request({
    url: process.env.WEB_API + '/oauth/render',
    method: 'post',
    params
  })
}

export function authVerify (params) {
  return request({
    url: process.env.WEB_API + '/oauth/verify/' + params,
    method: 'get',
  })
}

export function editUser (params) {
  return request({
    url: process.env.WEB_API + '/oauth/editUser',
    method: 'post',
    data: params
  })
}

export function loginGetImageVC (params) {
  return request({
    url: process.env.WEB_API + '/login/getImageVC',
    method: 'post',
    data: params
  })
}

/**
 * 更新用户密码
 * @param params
 */
export function updateUserPwd (params) {
  return request({
    url: process.env.WEB_API + '/oauth/updateUserPwd',
    method: 'post',
    data: params
  })
}

/**
 * 获取用户反馈
 * @param params
 */
export function getFeedbackList (params) {
  return request({
    url: process.env.WEB_API + '/oauth/getFeedbackList',
    method: 'get',
    params
  })
}

/**
 * 获取用户收藏列表
 * @param params
 */
export function collectGetListByUser (params) {
  return request({
    url: process.env.WEB_API + '/collect/getListByUser',
    method: 'post',
    data: params
  })
}

/**
 * 新增反馈
 * @param params
 */
export function addFeedback (params) {
  return request({
    url: process.env.WEB_API + '/oauth/addFeedback',
    method: 'post',
    data: params
  })
}

export function replyBlogLink (params) {
  return request({
    url: process.env.WEB_API + '/oauth/replyBlogLink',
    method: 'post',
    data: params
  })
}

export function deleteUserAccessToken (params) {
  return request({
    url: process.env.WEB_API + '/login/logout',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': getCookie('token')
    },
  })
}

/**
 * 本地登录
 * @param params
 */
export function localLogin (params) {
  return request({
    url: process.env.WEB_API + '/login/login',
    method: 'post',
    data: params
  })
}

/**
 * 本地注册
 * @param params
 */
export function localRegister (params) {
  return request({
    url: process.env.WEB_API + '/login/register',
    method: 'post',
    data: params
  })
}

/**
 * 本地注册
 * @param params
 */
export function loginResetPasswordBySms (params) {
  return request({
    url: process.env.WEB_API + '/login/resetPasswordBySms',
    method: 'post',
    data: params
  })
}

export function logout (params) {
  return request({
    url: process.env.WEB_API + '/user/logout',
    method: 'post',
    data: params
  })
}

/**
 * 获取微信公众号登录二维码
 * @param params
 * @returns {*}
 */
export function getWechatOrCodeTicket (params) {
  return request({
    url: process.env.WEB_API + '/wechat/getWechatOrCodeTicket',
    method: 'get',
    data: params
  })
}

export function getUserLoginStatus (params) {
  return request({
    url: process.env.WEB_API + '/wechat/getUserLoginStatus',
    method: 'get',
    params
  })
}

// 获取验证码
export function loginsendSms (params) {
  return request({
    url: process.env.WEB_API + '/login/sendSms',
    method: 'post',
    data: params,
  })
}

// 手机号登录
export function loginByTel (params) {
  return request({
    url: process.env.WEB_API + '/login/loginByTel',
    method: 'post',
    data: params,
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js